import React, { useRef, useState, useEffect } from 'react';
import { FormControlLabel, Switch, styled } from '@nextiva/next-ui-components';

import colors from 'styles/application/_base/_variables.scss';
import { pxToRem } from 'utils/pxToRemConverter';

const animation =
  'left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;';

const SwitchStyles = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .MuiSwitch-root {
    display: flex;
    padding: 0;
    width: 56px;
    height: 30px;
  }

  span.MuiSwitch-switchBase {
    padding: 1px 2px 2px;
    color: ${colors.white};

    &.Mui-checked {
      color: ${colors.white};
      & + .MuiSwitch-track {
        position: absolute;
        opacity: 1;
        background-color: ${colors.primaryBlue};
        border-color: ${colors.primaryBlue};
      }
    }

    &:after {
      content: 'Off';
      display: ${({ display }) => !display};
      padding: 0 0 0 3px;
      font-size: ${pxToRem('14px')};
      font-weight: 400;
    }
  }

  .Mui-checked {
    &:before {
      content: 'On';
      display: ${({ display }) => display};
      padding: 0 6px 0 1px;
      font-size: ${pxToRem('14px')};
      font-weight: 400;
    }
  }

  span.MuiSwitch-switchBase.Mui-checked {
    transform: translateX(
      ${({ display }) => (display === 'block' ? '4px' : '26px')}
    );
    transition: ${({ display }) => (display === 'block' ? 'none' : animation)};
  }

  .MuiButtonBase-root:hover {
    background-color: transparent;
  }

  span.MuiSwitch-thumb {
    width: 24px;
    height: 24px;
    box-shadow: none;
  }

  span.MuiSwitch-track {
    position: absolute;
    background-color: ${colors.disabled};
    border: 1px solid ${colors.disabled};
  }
`;

export const SwitchWrapper = ({ label, ...props }) => {
  const [display, setDisplay] = useState('block');

  const element = useRef(null);

  useEffect(() => {
    const updateDisplay = () => {
      setDisplay('block');
    };

    element.current?.addEventListener('transitionend', updateDisplay);

    return () =>
      element.current?.removeEventListener('transitionend', updateDisplay);
  }, []);

  return (
    <SwitchStyles
      control={
        <Switch
          ref={(e) => {
            element.current = e;
          }}
          disableRipple
          {...props}
        />
      }
      display={display}
      label={label}
    />
  );
};

export default SwitchWrapper;
